/*
 * Layout Name: About Intro
 * Desc:
 */
import ReactMarkdown from "react-markdown"
import * as styles from "./AboutIntro.module.scss"
import useMediaQuery from "@lib/useMediaQuery"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import cake from "@images/pages/about/cake.svg"
import flowers from "@images/pages/about/flowers.svg"
import gift from "@images/pages/about/gift.svg"
import lights from "@images/pages/about/lights.svg"
import oval from "@images/pages/about/oval.svg"

const AboutIntro = ({ title, subtitle, intro }) => {
  // Resize control
  const isMobile = useMediaQuery(767)

  return (
    <section className={styles.AboutIntro}>
      <img className={styles.circleRight} src={oval} alt="" />
      <SiteWrapper className={styles.wrapper}>
        <Section className={styles.intro}>
          <h1>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>
          <ReactMarkdown>{intro}</ReactMarkdown>
        </Section>
        <div className={styles.icons}>
          <img src={gift} alt="" />
          <img src={cake} alt="" />
          <img src={flowers} alt="" />
          <img src={lights} alt="" />
        </div>
      </SiteWrapper>
    </section>
  )
}

export default AboutIntro
